import { createAction } from '@reduxjs/toolkit';

export const reportError = createAction('ERROR::REPORT');
